import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Role } from '../../../_helpers/role';
import { Button, Spinner } from 'react-bootstrap';
import { search } from '../../../_actions/form.actions';
import { connect } from 'react-redux';

import moment from 'moment';
import DataTable from 'react-data-table-component';
import FormsEmpty from './Empty';
import queryString from 'query-string';
import SearchFilters from './SearchFilters';

import ExportForms from './Components/ExportForms';
import SentActions from './Components/SentActions';
import StatusPopover from './Components/StatusPopover';
import CanceledActions from './Components/CanceledActions';
import ScheduledActions from './Components/ScheduledActions';
import CompletedActions from './Components/CompletedActions';
import DetailsComponent from './Details';
import { formConstants } from '../../../_constants/form.constants';

import { Can } from "../../../_contexts/AbilitiesContext"

class List extends Component {

  constructor(props) {
    super(props);

    this.state = {
      initLoad: true,
    }

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    const { currentUser } = this.props;

    if (currentUser.UserType.Name === 'Licensed') {
      const providerId = currentUser.Doctor.DoctorId;
      this.props.history.push(`/forms?professional=${providerId}&time=${Date.now()}`)
    } else {
      this.loadData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      if (this.state.initLoad && this.props.collection.length > 0) {
        this.setState({ initLoad: false })
      }
      this.loadData();
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: formConstants.FORMS_GETALL_INIT });
  }

  loadData() {
    const searchParams = this.searchParams();

    this.props.dispatch(search(searchParams));
  }

  searchParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("completeByStartDate" in queryParams) ? true : false;

    return {
      page: queryParams.page || 1,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      completeByDate: !showDateRange ? queryParams.completeByDate || '' : '',
      completeByStartDate: showDateRange ? queryParams.completeByStartDate || '' : '',
      completeByEndDate: showDateRange ? queryParams.completeByEndDate || '' : '',
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      status: queryParams.status || '',
      form: queryParams.form ? parseInt(queryParams.form) : '',
    }
  }

  render() {
    const columns = [
      {
        name: <StatusPopover />,
        width: '100px',
        sort: false,
        cell: form => <span className='badge badge-info text-uppercase'>{form.status}</span>
      },
      {
        name: 'Patient Name',
        sort: false,
        cell: row => {
          if (row.userProfile) {
            return `${row.userProfile.firstName} ${row.userProfile.lastName}`
          } else {
            return `${row.patientFirstName} ${row.patientLastName}`
          }
        }
      },
      {
        name: 'Complete By',
        sort: false,
        cell: row => {
          return <>
            {moment.tz(row.completeByDate.date, row.completeByDate.timezone).local().format('l LT')}
          </>
        }
      },
      {
        name: 'Provider',
        sort: false,
        cell: row => {
          return `${row.doctor.firstName} ${row.doctor.lastName}`
        }
      },
      {
        name: 'Location',
        sort: false,
        cell: row => {
          return row.providerGroup.name
        }
      },
      {
        name: 'Form',
        sort: false,
        cell: form => {
          return form.questionnaire.title
        }
      },
      {
        button: true,
        width: '250px',
        sort: false,
        style: { justifyContent: "left" },
        cell: (form) => {
          if (form.status === 'SCHEDULED') {
            return <ScheduledActions form={form} />
          }
          if (form.status === 'SENT') {
            return <SentActions loadData={this.loadData} form={form} />
          }
          if (form.status === 'COMPLETED') {
            return <CompletedActions form={form} />
          }
          if (form.status === 'CANCELED') {
            return <CanceledActions form={form} />
          }
        }
      }
    ];

    const { isSearching, collection, total } = this.props;

    const urlParams = this.searchParams();

    return (
      <div className="row">
        <div className="col-lg-10 offset-lg-2">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="h2"><i className="far fa-file-alt"></i> Forms</h1>
            </div>

            <div className="col-lg-6">
              <div className="row" style={{ justifyContent: "flex-end" }}>
                <Can I="send" a="form">
                  <div className="col-lg-4">
                    <Button block variant="primary" as={Link} to="/forms/schedule">Send Form</Button>
                  </div>
                </Can>

                <Can I="export" a="form">
                  <div className="col-lg-auto">
                    <ExportForms />
                  </div>
                </Can>

              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-2">
              <SearchFilters location={this.props.location} handleSearch={(params) => {
                const { firstName, lastName, dateOfBirth, completeByDate, completeByStartDate, completeByEndDate, form, location, professional, status, showDateRange } = params;

                const startDate = completeByStartDate ? moment(completeByStartDate).format("L") : '';
                const endDate = completeByEndDate ? moment(completeByEndDate).format("L") : '';

                this.props.history.replace(`/forms?firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}${showDateRange ? `&completeByStartDate=${startDate}&completeByEndDate=${endDate}` : `&completeByDate=${completeByDate}`}&location=${location}&professional=${professional}&form=${form}&status=${status}`)
              }} />
            </div>
            <div className="col-lg-10">
              {isSearching && this.state.initLoad ?
                <Spinner animation="border" role="status" />
                :
                this.state.initLoad && collection.length === 0 ?
                  <FormsEmpty />
                  :
                  <DataTable
                    overflowY
                    columns={columns}
                    data={collection}
                    progressPending={isSearching}
                    onChangePage={page => {
                      const queryParams = queryString.parse(this.props.location.search);
                      const showDateRange = ("completeByStartDate" in queryParams) ? true : false;

                      const firstName = queryParams.firstName || '';
                      const lastName = queryParams.lastName || '';
                      const dateOfBirth = queryParams.dateOfBirth || '';
                      const completeByDate = queryParams.completeByDate || '';
                      const completeByStartDate = queryParams.completeByStartDate || '';
                      const completeByEndDate = queryParams.completeByEndDate || '';
                      const location = queryParams.location ? parseInt(queryParams.location) : '';
                      const professional = queryParams.professional ? parseInt(queryParams.professional) : '';
                      const form = queryParams.form ? parseInt(queryParams.form) : '';
                      const status = queryParams.status || '';

                      this.props.history.replace(`/forms?page=${page}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}${showDateRange ? `&completeByStartDate=${completeByStartDate}&completeByEndDate=${completeByEndDate}` : `&completeByDate=${completeByDate}`}&location=${location}&professional=${professional}&form=${form}&status=${status}`)
                    }}
                    noHeader={true}
                    subHeader={false}
                    striped={true}
                    pagination={true}
                    paginationServer={true}
                    paginationTotalRows={total}
                    paginationRowsPerPageOptions={[15]}
                    paginationPerPage={15}
                    paginationDefaultPage={parseInt(urlParams.page)}
                    expandableRows
                    expandOnRowClicked
                    expandableRowsComponent={<DetailsComponent />}
                    noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
                    customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
                  />
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    total: state.form.collection.collection ? state.form.collection.total : 0,
    collection: state.form.collection.collection ? state.form.collection.collection.data : [],
    currentUser: state.user.currentUser,
    isSearching: state.form.isSearching
  };
}

export default connect(mapStateToProps)(List);